import { render } from "./WaiverApproved.vue?vue&type=template&id=21349bad&scoped=true"
import script from "./WaiverApproved.vue?vue&type=script&lang=js"
export * from "./WaiverApproved.vue?vue&type=script&lang=js"

import "./WaiverApproved.vue?vue&type=style&index=0&id=21349bad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21349bad"]])

export default __exports__